// Copyright (c) 2022 Enabler Interactive Pty Ltd

import React, { Component } from 'react'
import { Row, Col } from 'react-bootstrap'

export class Message extends Component {
    render() {
        if (this.props.embedType === "tbody") {
            return (
                <tr className="loading-panel">
                    <td>
                        <Row className="message-panel">
                            <Col>
                                <p>{this.props.text}</p>
                                {this.props.children}
                            </Col>
                        </Row>
                    </td>
                </tr>
            )
        } else {
            return (
                <Row className="message-panel">
                    <Col>
                        <p>{this.props.text}</p>
                        {this.props.children}
                    </Col>
                </Row>
            )
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/message.js